import React, { useState, useEffect } from 'react';
 import './Taskassignment.css';

function TaskAssignment() {
  const [formData, setFormData] = useState({
    projectTitle: '',
    assignTo: '',
    startDate: '',
    endDate: '',
    remarks: '',
  });
  const [projectManagers, setProjectManagers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');

  useEffect(() => {
    const fetchProjectManagers = async () => {
      setLoading(true);
      try {
        const response = await fetch('https://cleezoclass.com:8443/api/project-managers');
        if (response.ok) {
          const data = await response.json();
          setProjectManagers(data);
        } else {
          setError(`Failed to fetch project managers. Status: ${response.status}`);
        }
      } catch (error) {
        setError('Error fetching project managers.');
      } finally {
        setLoading(false);
      }
    };

    fetchProjectManagers();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('https://cleezoclass.com:8443/api/task', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      if (response.ok) {
        setSuccessMessage('Task assignment stored successfully!');
        setFormData({
          projectTitle: '',
          assignTo: '',
          startDate: '',
          endDate: '',
          remarks: '',
        });
      } else {
        setError('Failed to save task.');
        setSuccessMessage('');
      }
    } catch (error) {
      setError('Error saving task.');
      setSuccessMessage('');
    }
  };

  return (
    <div className="task-page-container">
      <form onSubmit={handleSubmit} className="task-form wide-form">
        <h1 className="task-title">Task Assignment</h1>
        {loading && <p className="task-loading">Loading project managers...</p>}
        {error && <p className="task-error">{error}</p>}
        
        <div className="task-form-grid expanded-width">
          <div className="task-form-group">
            <label htmlFor="projectTitle" className="task-label">Project Title</label>
            <input
              type="text"
              id="projectTitle"
              name="projectTitle"
              value={formData.projectTitle}
              onChange={handleChange}
              required
              className="task-input"
            />
          </div>
          <div className="task-form-group">
            <label htmlFor="assignTo" className="task-label">Assign To</label>
            <select
              id="assignTo"
              name="assignTo"
              value={formData.assignTo}
              onChange={handleChange}
              required
              className="task-select"
            >
              <option value="">Select</option>
              {projectManagers.map((manager, index) => (
                <option key={index} value={manager}>{manager}</option>
              ))}
            </select>
          </div>
          <div className="task-form-group">
            <label htmlFor="startDate" className="task-label">Start Date</label>
            <input
              type="date"
              id="startDate"
              name="startDate"
              value={formData.startDate}
              onChange={handleChange}
              required
              className="task-input"
            />
          </div>
          <div className="task-form-group">
            <label htmlFor="endDate" className="task-label">End Date</label>
            <input
              type="date"
              id="endDate"
              name="endDate"
              value={formData.endDate}
              onChange={handleChange}
              required
              className="task-input"
            />
          </div>
        </div>

        <div className="task-form-group">
          <label htmlFor="remarks" className="task-label">Remarks</label>
          <textarea
            id="remarks"
            name="remarks"
            value={formData.remarks}
            onChange={handleChange}
            className="task-textarea"
          />
        </div>

        <button type="submit" className="task-submit-btn">Submit</button>
        {successMessage && <p className="task-success">{successMessage}</p>}
      </form>
    </div>
  );
}

export default TaskAssignment;
